import { Component, OnInit } from '@angular/core';
import { Router, RouterLinkActive, RouterLink } from '@angular/router';
import { GoogleAnalyticsService } from 'ngx-google-analytics';
import { Ga4Service } from 'src/app/services/ga4.service';
import { IframeService } from 'src/app/services/iframe.service';
import { NgClass, NgFor } from '@angular/common';

interface List {
  active: boolean;
  name: string;
  link: string;
  event: string;
}

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: true,
  imports: [NgClass, NgFor, RouterLinkActive, RouterLink],
})
export class HeaderComponent implements OnInit {
  list: List[] = [
    {
      active: false,
      name: 'Inicio',
      link: 'https://yoint.co',
      event: 'demo-header-main',
    },
    {
      active: false,
      name: 'Productos',
      link: 'https://yoint.co/#products',
      event: 'demo-header-products',
    },
    {
      active: false,
      name: 'Casos de uso',
      link: 'https://yoint.co/#caseUsed',
      event: 'demo-header-case-use',
    },
    // { active: false, name: 'Consultas', link: '/consults' event: ' },
    {
      active: false,
      name: 'Documentos',
      link: 'https://yoint.co/documentos',
      event: 'demo-header-documents',
    },
    { active: false, name: 'Demo', link: '/demo', event: 'demo-header-demo' },
    {
      active: false,
      name: 'Blog',
      link: 'https://yoint.co/blog',
      event: 'demo-header-blog',
    },
    {
      active: false,
      name: 'Contáctanos',
      link: 'https://yoint.co/contactanos',
      event: 'demo-header-contact',
    },
  ];

  constructor(
    private ga4Service: Ga4Service,
    private iframeService: IframeService,
    private router: Router
  ) {}

  ga4(event: string) {
    this.ga4Service.ga4(event);
  }

  ngOnInit(): void {
    const { pathname } = window.location;
    this.list.forEach((item) => item.link === pathname && (item.active = true));
  }

  toggle(index: number): void {
    this.list.forEach((item) => (item.active = false));
    this.list[index].active = true;
  }

  isIframe(): boolean {
    return this.iframeService.isIframe();
  }

  openTab(index: number): void {
    this.toggle(index);
    if (this.list[index].link.includes('http')) {
      window.open(this.list[index].link, '_self');
    } else {
      this.router.navigate([this.list[index].link]);
    }
  }

  openRegister(): void {
    window.open('https://ond.yoint.co', '_self');
  }
}
